<div class="header-card d-flex bottom-xs">
    <h2 class="color-blue-light header-card_title u-medium f-20">
        <ng-content></ng-content>
    </h2>
</div>
